import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT } from '@cfp/core';
import { LoginCard } from '@cfp/shared/ui/login';
import { FormGroupComponent, InputText } from '@cfp/ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PasswordService } from 'csr-login-app';
import { LoginLoadingSpinner, LoginMessages } from '../../components';
import { LoginFormService } from '../../services';

@Component({
  selector: 'cfp-unlock-account-page',
  templateUrl: './unlock-account-page.html',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    LoginMessages,
    LoginLoadingSpinner,
    FormsModule,
    RouterLink,
    FormGroupComponent,
    LoginCard,
    InputText
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnlockAccountPage {
  protected readonly isLoading = signal(false);
  protected readonly isFormSubmitSuccess = signal(false);
  protected readonly successMessages = signal<string[]>([]);
  protected readonly warningMessages = signal<string[]>([]);
  protected readonly errorMessages = signal<string[]>([]);

  protected form: FormGroup;
  protected currentLang: string;

  private readonly environment = inject(ENVIRONMENT);
  private readonly loginFormService = inject(LoginFormService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);
  private readonly passwordService = inject(PasswordService);

  protected loginRoute = this.environment.loginRoute;

  constructor() {
    const group: any = {
      username: ['', Validators.required]
    };

    this.form = this.formBuilder.group(group);

    this.currentLang = this.translateService.currentLang;
  }

  protected send(): void {
    if (this.validateForm()) {
      this.isLoading.set(true);
      this.passwordService
        .v2PasswordForgotpasswordPost({
          username: this.form.value.username,
          environmentCode: this.environment.environmentCode.dto
        })
        .subscribe({
          next: () => {
            this.isLoading.set(false);
            this.successMessages.set(['login.success.requestPasswordReset']);
            this.isFormSubmitSuccess.set(true);
          },
          error: () => {
            this.isLoading.set(false);
          }
        });
    }
  }

  protected validateForm(): boolean {
    this.errorMessages.set([]);

    if (this.form.status === 'INVALID') {
      this.errorMessages.set(this.loginFormService.transformErrorMessages(this.form));
      return false;
    } else {
      return true;
    }
  }
}
